export type PredictionBatchStatus = 'PENDING' | 'RUNNING' | 'SUCCEEDED' | 'FAILED';

export const STATUS_CODE_TO_STATUS: Record<string, PredictionBatchStatus> = {
  SUCCEEDED: 'SUCCEEDED',
  RUNNING: 'RUNNING',
  FAILED: 'FAILED',
  WAITING: 'PENDING',
  BLOCKED: 'PENDING',
};

export type SortField = 'createdAt' | 'modifiedAt';
export type SortDirection = 'asc' | 'desc';

export interface SortConfig {
  key: SortField;
  direction: SortDirection;
}

export interface PredictionBatchRow {
  id: string;
  name: string;
  status: PredictionBatchStatus;
  modelName: string;
  creatorName: string;
  createdAt: string;
  modifiedAt: string;
  folderName: string;
  numPredictionJobs: number | null;
}
